import type {IEnvConfigType} from "../../types/types";

export default {
    endpoints:{
        back: "https://api.matchid.ai/",
        auth:"https://auth.matchid.ai/"
    }
} as IEnvConfigType